module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water@3x_7f8339.jpg";